// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"616":"c1d4e9bd","634":"aeed368c","709":"b232227a","920":"cb908500","937":"394b863c"}[chunkId] + ".chunk.css";
};